import { QueryClient, QueryClientProvider, focusManager } from 'react-query'

export const client = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false
    }
  }
})

export default function QueryProvider(attr) {
  const props = {
    client,
    contextSharing: true,
    ...attr
  }

  focusManager.setFocused(false)

  return <QueryClientProvider {...props} />
}
